import isEmpty from 'lodash/isEmpty';
import { useNavigate } from 'react-router-dom';

import { ProcessTemplateForm } from '../process-template-form';
import { useCreateProcessTasksTemplate } from 'src/hooks/process-task-templates/create-tasks-template.hook';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';

import {
  IProcessesTemplateItem,
  IProcessTemplateItemTask,
} from '../../../process-templates-table/process-templates-table.interfaces';


const NewProcessTemplate = () => {
  const navigate = useNavigate();

  const { createProcessTasksTemplate } = useCreateProcessTasksTemplate({
    onSuccess: () => navigate(`${ROUTES.settings}?type=${SETTINGS_PAGES.processTemplates}`),
  });

  const onFinishHandler = (values: IProcessesTemplateItem, taskList: IProcessTemplateItemTask[]) => {
    const dataToCreate: {
      name: string;
      emailTemplateId: string;
      templateTasks?: IProcessTemplateItemTask[];
    } = {
      name: values.name,
      emailTemplateId: values.emailTemplateId,
    };

    if (!isEmpty(taskList)) {
      dataToCreate.templateTasks = taskList.map(({ key, ...el }) => {
        return el;
      });
    }

    return createProcessTasksTemplate({
      variables: {
        payload: dataToCreate,
      },
    });
  };

  return <ProcessTemplateForm onFinishHandler={onFinishHandler} />;
};

export default NewProcessTemplate;
